// extracted by mini-css-extract-plugin
export default {"container":"ContentBox_container__B79hz","header":"ContentBox_header__0w1Q-","content":"ContentBox_content__LgS+b"};